import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Typography } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey, GlobalClassKeys } from "assets/jss/common-styles";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { UsernameResolver } from "components/UsernameInspect";
import UserProfileAvatar from "components/UserProfileAvatar";
import UserProfileLink from "components/UserProfileLink";
import { Formaters } from "lib/Formarters";
import { FeedType, PublicationType } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";
import ApprovalStatusLine from "views/Timeline/Components/CardComp/ApprovalStatusLine";
import FlagsLine from "views/Timeline/Components/CardComp/FlagsLine";
import ListIcon from "views/Timeline/Components/CardComp/ListIcon";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    showRestriction: boolean;
}

interface IProps {
    ignoreBestAnswer?: boolean;
    feedType: FeedType;
    data: FeedItemDto;
}

type Props = IProps & StyledComponentProps<FeedClassKey> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class Publisher extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = { showRestriction: false };
    }

    static defaulProps = {
        ignoreBestAnswer: false
    };

    private showRestriction() {
        // TODO: modal com as lista restrições
    }

    render() {
        const { t, data: { publicationId, publicationType, publication, bestAnswer }, ignoreBestAnswer, feedType } = this.props;

        let creationDate = publication.creationDate;
        let lastUpdateDate = publication.lastUpdateDate;
        let revisor = publication.revisor;
        let isAnonymous = publication.isAnonymous;
        let publisher = publication.publisher;

        if (publicationType == PublicationType.Question && bestAnswer && bestAnswer.publication.publishDate && !ignoreBestAnswer) {
            creationDate = bestAnswer.publication.creationDate;
            lastUpdateDate = bestAnswer.publication.lastUpdateDate;
            publisher = bestAnswer.publication.publisher;
            revisor = bestAnswer.publication.revisor;
            isAnonymous = bestAnswer.publication.isAnonymous;
        }

        const finalPublisher =
            publication.isInstitutional == true
                ? publication.institutionalCreator
                : publisher;

        const publisherName = (isAnonymous === true)
            ? `${t("Common.Feed.Literals.AnonymousText")}`
            : UsernameResolver(finalPublisher);

        const inMyPublications = (feedType == FeedType.MyPublication || feedType == FeedType.MyDraft || feedType == FeedType.MyAnswers);

        const hideName =
            (publisher.id == Session.user.id && inMyPublications)
            ||
            (publicationType === PublicationType.List && !publication.isPublic);

        const revision = publication.isInstitutional === false && isAnonymous === false && publisher && revisor && publisher.id != revisor.id
            ? <span>({t("Common.Feed.Literals.EditedByText")} <UserProfileLink user={publication.revisor} firstNameOnly />)</span>
            : publication.isInstitutional === true && inMyPublications
                ? <span>{`(${t("Common.Feed.Literals.InstitutionalText")})`}</span>
                : null;

        const notChanged = (lastUpdateDate.getTime() == creationDate.getTime());

        let label = notChanged
            ? (hideName ? t("Common.Feed.Literals.WasPublishedText") : t("Common.Feed.Literals.PublishedText"))
            : (hideName ? t("Common.Feed.Literals.WasUpdatedText") : t("Common.Feed.Literals.UpdatedText"));

        if (publicationType == PublicationType.Question) {
            if (bestAnswer == null || ignoreBestAnswer)
                label = hideName ? t("Common.Feed.Literals.WasAskedText") : t("Common.Feed.Literals.AskedText");
            else if (notChanged)
                label = hideName ? t("Common.Feed.Literals.WasAnsweredText") : t("Common.Feed.Literals.AnsweredText");
        }
        else if (publicationType == PublicationType.Answer && notChanged) {
            label = hideName ? t("Common.Feed.Literals.WasAnsweredText") : t("Common.Feed.Literals.AnsweredText");
        }

        const relativeTime = Formaters.relativeTime(lastUpdateDate);

        const pubLocked = publication.hasTopicRestriction && publication.parentPublicationType != PublicationType.Course && publicationType != PublicationType.List
            ? (<a onClick={() => { this.setState({ showRestriction: true }); }} title={t("Common.Feed.Literals.TopicRestrictionTitle")}><FontAwesomeIcon fixedWidth icon={faLock} /></a>)
            : null;

        const listIcon = publicationType == PublicationType.List
            ? <ListIcon isPublic={publication.isPublic} />
            : null;

        return (
            <MuiContainer margin="dense">
                {
                    !hideName
                        ? (
                            <Grid container spacing={1}>
                                {
                                    !isAnonymous &&
                                    <Grid item className={GlobalClassKeys.pushVCenter}>
                                        {
                                            publication.isInstitutional == false
                                                ? <UserProfileAvatar user={finalPublisher} />
                                                : <Avatar src={finalPublisher.thumbnailUrl} title={finalPublisher.name} />
                                        }
                                    </Grid>
                                }
                                <Grid item xs>
                                    <Typography variant="subtitle2" component="div">
                                        <MuiColor variant="muted">
                                            <small>
                                                <div><b>{publisherName}</b></div>
                                                <div>
                                                    {label} {relativeTime} {pubLocked} {listIcon} {revision} <FlagsLine flags={publication} /> <ApprovalStatusLine feedItem={this.props.data} /></div>
                                            </small>
                                        </MuiColor>
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                        : (
                            <Typography variant="subtitle2" component="div" >
                                <MuiColor variant="muted">
                                    <small>
                                        <div>{label} {relativeTime} {pubLocked} {listIcon} {revision} <FlagsLine flags={publication} /> <ApprovalStatusLine feedItem={this.props.data} /></div>
                                    </small>
                                </MuiColor>
                            </Typography>
                        )
                }

                {
                    this.state.showRestriction
                        ? this.showRestriction()
                        : null
                }
            </MuiContainer>
        );
    }
}

export default withTranslation()(Publisher);